import {
  OrderTrackingIntegrationType,
  OrderTrackingOrderStatus,
  OrderTrackingShipmentStatus,
} from "@redotech/order-tracking-common/order-tracking-types";
import * as zExt from "@redotech/rpc/ext";
import * as z from "zod";

const platformSchema = z.enum(["redo", "malomo"]);

const integrationSchema = z.enum(OrderTrackingIntegrationType);
const orderStatusSchema = z.enum(OrderTrackingOrderStatus);
const shipmentStatusSchema = z.enum(OrderTrackingShipmentStatus);

const eventTypeSchema = z.union([orderStatusSchema, shipmentStatusSchema]);

export const sendIntegrationEventTest = {
  name: "sendIntegrationEventTest" as const,
  input: z.object({
    teamId: zExt.objectId(),
    platform: platformSchema,
    integration: integrationSchema,
    eventType: eventTypeSchema,
    orderIdentifier: z.string().optional(),
    testEmail: z.string().optional(),
    testPhoneNumber: z.string().optional(),
  }),
  output: z.object({
    success: z.boolean(),
    error: z.string().nullable(),
    message: z.string().optional(),
  }),
};
